import React from 'react'
import { Switch } from 'react-router-dom'
import { ProtectedRoute } from 'components/ProtectedRoute'
import { CIMSPage, Permission } from '@cims-online/shared'
import EJQuickLinks from './components/EJQuickLinks'
import EJTypes from './components/Types'
import EJLog from './components/EJLog'
import EJNotifications from './components/EJNotifications'

const EngineeringJudgements: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={CIMSPage.EJLog.projectPath}
        permissions={Permission.ViewEngineeringJudgement}
      >
        <EJLog />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.EJTypes.projectPath}
        permissions={Permission.ViewEJType}
      >
        <EJTypes />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.EJQuickLinks.projectPath}
        permissions={Permission.ViewEJQuickLink}
      >
        <EJQuickLinks />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.EJNotifications.projectPath}
        permissions={Permission.ViewEJNotification}
      >
        <EJNotifications />
      </ProtectedRoute>
    </Switch>
  )
}

export default EngineeringJudgements
